import * as React from "react";
const SvgFiRrUserGraduate = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-user-graduate_svg__a)">
      <path
        fill="#062147"
        d="M22.004 4.498a1.99 1.99 0 0 0-1.34-1.898L14.199.319A6.5 6.5 0 0 0 9.897.312l-6.544 2.29A1.99 1.99 0 0 0 2.007 4.5c0 .866.529 1.61 1.347 1.896L6 7.319v1.68c0 3.31 2.69 6 6 6s6-2.69 6-6V7.319l2-.698v4.379a1 1 0 1 0 2 0zM16 9c0 2.206-1.794 4-4 4s-4-1.794-4-4v-.984l1.862.65a6.512 6.512 0 0 0 4.275 0L16 8.016zm-2.522-2.223a4.5 4.5 0 0 1-2.958 0L4.013 4.49l6.544-2.29a4.5 4.5 0 0 1 2.976.005l6.464 2.298zm6.847 16.02a1 1 0 0 1-1.96.406 6.52 6.52 0 0 0-2.935-4.196l-2.662 3.154c-.38.455-1.156.455-1.536 0L8.6 19.005a6.47 6.47 0 0 0-2.967 4.198 1 1 0 1 1-1.959-.405 8.53 8.53 0 0 1 3.837-5.488 2.03 2.03 0 0 1 2.625.413L12 19.958l1.862-2.235a2.03 2.03 0 0 1 2.624-.415 8.54 8.54 0 0 1 3.839 5.49"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-user-graduate_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUserGraduate;
